import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import {responsiveStateReducer} from 'redux-responsive'
import customers from './customers'
import customer from './customer'
import branch from './branch'
import transactions from './transaction'
import transactionday from './transactionday'
import branches from './branches'
import operators from './operators'
import operator from './operator'
import user from './user'
import status from './status'
import branchMap from './branchMap'
import customerMap from './customerMap'
import profile from './profile'
import fileexport from './fileexport'
import resetPassword from './resetPassword'
import forgotPassword from './forgotPassword'
import report from './report'
import menu from './menu'
import token from './token'
import i18n from './i18n'

const appReducer = combineReducers({
    customers,
    customer,
    branchPage: branch,
    transactions,
    transactionday,
    branches,
    operators,
    operatorPage: operator,
    user,
    profile,
    status,
    branchMap,
    customerMap,
    fileexport,
    resetPassword,
    token,
    forgotPassword,
    report,
    menu,
    language: i18n,
    form: formReducer,
    browser: responsiveStateReducer
});

const reducers = (state, action) => {
    if(action.type ==='LOGOUT' || (action.payload && action.payload.response && action.payload.response && action.payload.response.status === 401)){
        state = undefined;
    }
    return appReducer(state, action)
};

export default reducers;


// WEBPACK FOOTER //
// ./src/store/reducers/index.js